import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './style/Categories.css';

// Импортируем изображения
import Vegetables from './store_pictures/categories/vegetables.jpg';
import ChickenAndPoultry from './store_pictures/categories/chicken_and_poultry.jpg';
import Milk from './store_pictures/categories/milk.jpg';
import Cheese from './store_pictures/categories/cheese.jpg';
import Beef from './store_pictures/categories/beef.jpg';
import MeatSnacks from './store_pictures/categories/meat_snacks.jpg';
import Mutton from './store_pictures/categories/mutton.jpg';
import MeatDelicacies from './store_pictures/categories/Meat_delicacies.jpg';
import MeatByProducts from './store_pictures/categories/Meat_byy_products.jpg';
import Oil from './store_pictures/categories/oil.jpg';

const allCategories = [
  { id: 10, icon: Vegetables, name: 'Овощи' },
  { id: 2, icon: ChickenAndPoultry, name: 'Курица и птица' },
  { id: 7, icon: Milk, name: 'Молоко' },
  { id: 8, icon: Cheese, name: 'Сыры' },
  { id: 5, icon: Beef, name: 'Говядина' },
  { id: 6, icon: MeatSnacks, name: 'Мясные закуски' },
  { id: 1, icon: Mutton, name: 'Баранина' },
  { id: 3, icon: MeatDelicacies, name: 'Мясные деликатесы' },
  { id: 4, icon: MeatByProducts, name: 'Мясные субпродукты' },
  { id: 9, icon: Oil, name: 'Масло' },
];

const CategoryItem = ({ icon, name, id }) => (
  <Link to={`/catalog?category=${id}`} className="category-item" onClick={() => window.scrollTo(0, 0)}>
    <div className="category-icon" style={{ backgroundImage: `url(${icon})` }}></div>
    <div className="category-name">{name}</div>
  </Link>
);

const Categories = () => {
  const [showAll, setShowAll] = useState(false);

  const categoriesToShow = showAll ? allCategories : allCategories.slice(0, 7);

  return (
    <div className="categories-container">
      <div className="categories-text-container">
        <div className="categories-title">Категории</div>
        <div className="category-view-all" onClick={() => setShowAll(!showAll)}>
          {showAll ? 'Скрыть' : 'Смотреть все'}
        </div>
      </div>
      <div className="categories-list">
        {categoriesToShow.map((category, index) => (
          <CategoryItem key={index} icon={category.icon} name={category.name} id={category.id} />
        ))}
      </div>
    </div>
  );
};

export default Categories;
